const authHeaders = () => {
  const token = localStorage.getItem("authToken");
  return { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) };
};

export const createOrder = async (order) => {
  const response = await fetch("/api/orders", { method: "POST", headers: authHeaders(), body: JSON.stringify(order) });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || "خطا در ثبت سفارش");
  return result;
};
